export enum RgbSceneFormView {
  LIST = 'LIST',
  SET_COLOR = 'SET_COLOR',
  SETTINGS = 'SETTINGS',
  CHANGE_ICON = 'CHANGE_ICON',
  CHANGE_NAME = 'CHANGE_NAME',
  CHANGE_ORDER = 'CHANGE_ORDER',
  REMOVE_COLOR = 'REMOVE_COLOR',
}
